var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarUpcoming(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_392_6497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.972168 5.24989V2.80544C0.972168 2.64336 1.03655 2.48793 1.15115 2.37332C1.26576 2.25872 1.42119 2.19434 1.58327 2.19434H14.4166C14.5787 2.19434 14.7342 2.25872 14.8487 2.37332C14.9633 2.48793 15.0277 2.64336 15.0277 2.80544V5.24989H0.972168Z",
    fill: "#FF808C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.972168 3.72211V2.80544C0.972168 2.64336 1.03655 2.48793 1.15115 2.37332C1.26576 2.25872 1.42119 2.19434 1.58327 2.19434H14.4166C14.5787 2.19434 14.7342 2.25872 14.8487 2.37332C14.9633 2.48793 15.0277 2.64336 15.0277 2.80544V3.72211H0.972168Z",
    fill: "#FFBFC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 5.33301H14.722V14.4997C14.722 14.6617 14.6576 14.8172 14.543 14.9318C14.4285 15.0463 14.273 15.1108 14.111 15.1108H1.27761C1.11553 15.1108 0.960097 15.0463 0.845491 14.9318C0.730884 14.8172 0.666504 14.6617 0.666504 14.4997V5.33301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4171 2.19531H1.58376C1.24626 2.19531 0.972656 2.46891 0.972656 2.80643V14.4175C0.972656 14.755 1.24626 15.0286 1.58376 15.0286H14.4171C14.7546 15.0286 15.0282 14.755 15.0282 14.4175V2.80643C15.0282 2.46891 14.7546 2.19531 14.4171 2.19531Z",
    stroke: "#111827",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.02734 0.972656V4.02821",
    stroke: "#111827",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9727 0.972656V4.02821",
    stroke: "#111827",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.972656 5.25H15.0282",
    stroke: "#111827",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3335,
    y: 7.33301,
    width: 1.33333,
    height: 1.33333,
    rx: 0.133333,
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3335,
    y: 9.33301,
    width: 1.33333,
    height: 1.33333,
    rx: 0.133333,
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3335,
    y: 11.333,
    width: 1.33333,
    height: 1.33333,
    rx: 0.133333,
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 7.33301,
    width: 1.33333,
    height: 1.33333,
    rx: 0.133333,
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9.33301,
    width: 1.33333,
    height: 1.33333,
    rx: 0.133333,
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11.333,
    width: 1.33333,
    height: 1.33333,
    rx: 0.133333,
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.66699,
    y: 7.33301,
    width: 1.33333,
    height: 1.33333,
    rx: 0.133333,
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.66699,
    y: 9.33301,
    width: 1.33333,
    height: 1.33333,
    rx: 0.133333,
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3335,
    y: 7.33301,
    width: 1.33333,
    height: 1.33333,
    rx: 0.133333,
    fill: "#111827"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_392_6497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarUpcoming);
export default __webpack_public_path__ + "static/media/CalendarUpcoming.be82c07f544b0045cf67a8b44b664ad3.svg";
export { ForwardRef as ReactComponent };